var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.504,
    height: 38.413,
    viewBox: "0 0 32.504 38.413",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "share-svgrepo-com",
    d: "M29.351,2.25a6.407,6.407,0,0,0-6.3,7.533L13.73,16.306a1.49,1.49,0,0,0-.134.106,6.4,6.4,0,1,0,0,10.088,1.486,1.486,0,0,0,.134.106l9.319,6.523a6.4,6.4,0,1,0,1.215-2.756L15.44,24.2a6.418,6.418,0,0,0,0-5.481l8.824-6.177A6.4,6.4,0,1,0,29.351,2.25ZM25.9,8.652A3.447,3.447,0,1,1,29.351,12.1,3.447,3.447,0,0,1,25.9,8.652ZM9.652,18.009A3.447,3.447,0,1,0,13.1,21.457,3.447,3.447,0,0,0,9.652,18.009Zm19.7,12.8A3.447,3.447,0,1,0,32.8,34.261,3.447,3.447,0,0,0,29.351,30.814Z",
    transform: "translate(-3.25 -2.25)",
    fill: "#111",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareBlack);
export default __webpack_public_path__ + "static/media/share_black.3e5216518aaf8fd748fd3c88613823a3.svg";
export { ForwardRef as ReactComponent };